import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function CheckIcon() {
  return <FontAwesomeIcon icon={faCheck} className="h-auto" />;
}

export default CheckIcon;
